import { render, staticRenderFns } from "./ClinicDoctorNew.vue?vue&type=template&id=8714fe46&scoped=true"
import script from "./ClinicDoctorNew.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorNew.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctorNew.vue?vue&type=style&index=0&id=8714fe46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8714fe46",
  null
  
)

export default component.exports